import { RequestEvent } from 'common/event';
import { LookupItem } from 'runtime/data/lookupitem';

export class LookupItemsRequested extends RequestEvent<LookupItemsRequested, LookupItem[]> {
    constructor(public fieldName: string, public fieldContext: string) {
        super();
    }
}